import { Input } from '../shared-components/BUI/Input'

import { useLocale } from '@/context/localeContext'
import { formatMobile } from '@/utils/formatMobile'

type Props = {
  autoAddPrefix?: boolean
  value?: string
  onChange?: (value: string) => void
  tel?: boolean
}

export const MobileInput: React.FC<Props> = ({
  value,
  onChange,
  autoAddPrefix = false,
  tel,
  ...rest
}) => {
  const { t } = useLocale()

  const customOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value

    if (value.length <= 9) {
      onChange?.(value)
      return
    }

    const formattedValue = autoAddPrefix ? formatMobile(value) : value.trim()

    onChange?.(formattedValue)
  }

  return (
    <Input
      placeholder={t('common:placeholders.phoneNumber')}
      value={value}
      onChange={customOnChange}
      type={tel ? 'tel' : undefined}
      {...rest}
    />
  )
}
